<script>
  import axios from 'axios';
  import AS from '@/services/AuthenticationService';

  export default {
    // params: { page, limit, q, status, application_type_id, typology_id,
    //           locked_by_id, payment_status, created_from, created_to, sort, direction }
    all(params) {
      return axios.get('admin/requerimentos', { ...AS.getDefaultHeaders(), params });
    },
    pendingAnalysis() {
      return axios.get('admin/pending_analysis', AS.getDefaultHeaders());
    },
  };
</script>
